export const state = () => ({
  saleRateList: [],
  masterSaleFormatList: [],
  serviceList: [],
  predictionPeriodList: [],
  pointOfSaleSettings: null,
  newProducts: null,
  masterProductList: [],
  masterProductListCancelToken: null,
  masterProductProgress: 0.0,
  groupOfProductPricingList: [],
  options: [],
  menuList: []
});
